const info = {
    $schema: '../../../assetlist.schema.json',
    chain_name: 'ethereumtestnet',
    assets: [
        {
            description: 'Ether is the native fee token of the Ethereum network.',
            denom_units: [
                {
                    denom: 'wei',
                    exponent: 0
                },
                {
                    denom: 'gwei',
                    exponent: 9
                },
                {
                    denom: 'eth',
                    exponent: 18,
                    aliases: ['ether']
                }
            ],
            type_asset: 'evm-base',
            base: 'wei',
            name: 'Ether',
            display: 'eth',
            symbol: 'ETH',
            traces: [{
                    type: 'test-mintage',
                    counterparty: {
                        chain_name: 'ethereum',
                        base_denom: 'wei'
                    },
                    provider: 'Ethereum'
                }],
            logo_URIs: {
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eth.svg'
            },
            coingecko_id: 'ethereum',
            images: [{
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eth.svg'
                }]
        },
        {
            description: 'wETH is \'wrapped ETH\'',
            type_asset: 'erc20',
            address: '0xB4FBF271143F4FBf7B91A5ded31805e42b2208d6',
            denom_units: [{
                    denom: '0xB4FBF271143F4FBf7B91A5ded31805e42b2208d6',
                    exponent: 0,
                    aliases: ['weth-wei']
                }, {
                    denom: 'weth',
                    exponent: 18
                }],
            base: '0xB4FBF271143F4FBf7B91A5ded31805e42b2208d6',
            name: 'Wrapped Ether',
            display: 'weth',
            symbol: 'WETH',
            traces: [{
                    type: 'wrapped',
                    counterparty: {
                        chain_name: 'ethereumtestnet',
                        base_denom: 'wei'
                    },
                    provider: 'Ethereum'
                }],
            logo_URIs: {
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/weth.svg'
            },
            coingecko_id: 'weth',
            images: [{
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/weth.svg'
                }]
        },
        {
            description: 'USDC is a fully collateralized US Dollar stablecoin developed by CENTRE, the open source project with Circle being the first of several forthcoming issuers.',
            type_asset: 'erc20',
            address: '0x254d06f33bDc5b8ee05b2ea472107E300226659A',
            denom_units: [{
                    denom: '0x254d06f33bDc5b8ee05b2ea472107E300226659A',
                    exponent: 0,
                    aliases: ['uausdc']
                }, {
                    denom: 'ausdc',
                    exponent: 6
                }],
            base: '0x254d06f33bDc5b8ee05b2ea472107E300226659A',
            name: 'USD Coin',
            display: 'ausdc',
            symbol: 'aUSDC',
            traces: [{
                    type: 'test-mintage',
                    counterparty: {
                        chain_name: 'ethereum',
                        base_denom: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48'
                    },
                    provider: 'Ethereum'
                }],
            logo_URIs: {
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg'
            },
            coingecko_id: 'usd-coin',
            images: [{
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg'
                }]
        },
        {
            type_asset: 'erc20',
            address: '0xaA8E23Fb1079EA71e0a56F48a2aA51851D8433D0',
            denom_units: [{
                    denom: '0xaA8E23Fb1079EA71e0a56F48a2aA51851D8433D0',
                    exponent: 0,
                    aliases: ['uusdt']
                }, {
                    denom: 'usdt',
                    exponent: 6
                }],
            base: '0xaA8E23Fb1079EA71e0a56F48a2aA51851D8433D0',
            name: 'Tether USD',
            display: 'usdt',
            symbol: 'USDT',
            traces: [{
                    type: 'test-mintage',
                    counterparty: {
                        chain_name: 'ethereum',
                        base_denom: '0xdac17f958d2ee523a2206206994597c13d831ec7'
                    },
                    provider: 'Tether'
                }],
            coingecko_id: 'tether',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png',
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg'
            },
            images: [{
                    image_sync: {
                        chain_name: 'ethereum',
                        base_denom: '0xdac17f958d2ee523a2206206994597c13d831ec7'
                    },
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg',
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png',
                    theme: {
                        circle: true,
                        primary_color_hex: '#009393',
                        background_color_hex: '#009393'
                    }
                }, {
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt_logomark.png',
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt_logomark.svg',
                    theme: {
                        circle: false,
                        primary_color_hex: '#50AF95',
                        background_color_hex: '#00000000'
                    }
                }]
        }
    ]
};
export default info;
